import {
  selectImpersonatedUserId,
  useGetLoggedInUser,
  useImpersonationSelector,
} from '@revelio/auth';

/**
 * User id for reading the effective user's own content (reports, resumes,
 * dashboards) — the impersonated user when impersonating, else the real user.
 * READS only; writes always target the real logged-in user.
 */
export const useEffectiveUserId = (): string | undefined => {
  const impersonatedUserId = useImpersonationSelector(selectImpersonatedUserId);
  const { loggedInUser } = useGetLoggedInUser();
  return impersonatedUserId ?? loggedInUser.id ?? undefined;
};
